import ErrorBaseView from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';
import { ErrorBaseViewController } from '@/lib/types/layout.ts';

export const HometaxOverloadControlError = () => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_megaphone_md.svg`} className={'w-[88px] h-[88px]'} alt={''} />,
    title: '앗, 현재 홈택스 이용자가 많아\n확인이 늦어지고 있어요',
    description: '저녁 7시 이후에 다시 시도해주세요.'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};
